import {
	SET_ACTIVATION_CODE_FLAG,
	SET_ADDRESS_STRIPE_INFOS, SET_AMOUNT_OFF,
	SET_CITY_STRIPE_INFOS, SET_CUSTOMER_ID,
	SET_EMAIL_STRIPE_INFOS,
	SET_FIRSTNAME_STRIPE_INFOS,
	SET_LASTNAME_STRIPE_INFOS, SET_OFFER_PRICE, SET_PERCENT_OFF,
	SET_POSTAL_CODE_STRIPE_INFOS,
	SET_PROMOTION_CODE, SET_PROMOTION_CODE_FLAG, SET_PROMOTION_CODE_ID,
	SET_TEL_STRIPE_INFOS
} from "../actions/stripePayment";


export const initialState = {
	userInfos : {
		"firstname" : "",
		"lastname": "",
		"tel": "",
		"email": "",
		"address": "",
		"city": "",
		"postalCode": "",
		"promotionCodeId": "",
	},
	customerId: "",
	offerPrice: 0,
	promotionCode: "",
	promotionCodeFlag: false,
	activationCodeFlag: false,
};

const stripePayment = (state = initialState, action = {}) => {
	switch (action.type) {
	// Ici les actions permettant de mettre à jour les coordonnées utilisateur
	case SET_FIRSTNAME_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				firstname: action.firstname
			}
		};
	}
	case SET_LASTNAME_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				lastname: action.lastname
			}
		};
	}
	case SET_EMAIL_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				email: action.email
			}
		};
	}
	case SET_ADDRESS_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				address: action.address
			}
		};
	}
	case SET_CITY_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				city: action.city
			}
		};
	}
	case SET_POSTAL_CODE_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				postalCode: action.postalCode
			}
		};
	}
	case SET_TEL_STRIPE_INFOS : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				tel: action.tel
			}
		};
	}
	case SET_CUSTOMER_ID : {
		return {
			...state,
			customerId: action.id
		};
	}
	case SET_OFFER_PRICE : {
		return {
			...state,
			offerPrice: action.price
		};
	}
	case SET_PROMOTION_CODE : {
		return {
			...state,
			promotionCode : action.code
		};
	}
	// Determine si un code promo a déjà été rentré
	case SET_PROMOTION_CODE_FLAG : {
		return {
			...state,
			promotionCodeFlag : action.bool
		};
	}
	// Détermine si le code promo correspond en réalité à un code d'activation
	case SET_ACTIVATION_CODE_FLAG : {
		return {
			...state,
			activationCodeFlag : action.bool
		};
	}
	case SET_PROMOTION_CODE_ID : {
		return {
			...state,
			userInfos: {
				...state.userInfos,
				promotionCodeId : action.id
			}
		};
	}
	// Pourcentage de réduction
	case SET_PERCENT_OFF : {
		return {
			...state,
			percentOff: action.percent
		};
	}
	// Montant de la réduction
	case SET_AMOUNT_OFF : {
		return {
			...state,
			amountOff : action.amount
		};
	}
	default:
		return state;
	}
};

export default stripePayment;